module.exports = __webpack_public_path__ + "static/media/landing.430a3af7.png";